import { render, staticRenderFns } from "./TenantFlow.vue?vue&type=template&id=901b60bc"
import script from "./TenantFlow.vue?vue&type=script&lang=js"
export * from "./TenantFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports